import styled from 'styled-components';

export const ToothContainer = styled.div`
  display: flex;
  padding: 10px;
  justify-content: space-around;
`;

export const ToothDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #cdcdcd;
  border-radius: 4px;
  padding: 20px;
`;

export const TitleToothText = styled.div`
  font-size: 13px;
  color: #898787ff;
`;

export const ValueToothText = styled.div`
  font-size: 30px;
`;
